import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 8l2 5l2 -5","key":"svg-0"}],["path",{"d":"M12 16v-3","key":"svg-1"}]]

const IconLetterYSmall = createReactComponent('outline', 'letter-y-small', 'LetterYSmall', __iconNode);

export default IconLetterYSmall;